import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchProviderInformation = createAsyncThunk(
  "fetchProviderInformation",
  async (providersId) => {
    const result = await FetchRequestHandler("get", `${baseUrl}api/providers/${providersId}?view=extended`);
    return result;
  }
)


export const fetchUpdateProviderInformation = createAsyncThunk(
  "fetchUpdateProviderInformation",
  async ({providersId,payload}) => {
    console.log("payload : ", payload);
    const result = await FetchRequestHandler("put", `${baseUrl}api/providers/${providersId}?view=extended`, payload);
    return result;
  }
)



export const fetchProvidersPhotos = createAsyncThunk(
  "fetchProvidersPhotos",
  async (providersId) => {
    const result = await FetchRequestHandler("get", `${baseUrl}api/providers/${providersId}/photos?filter=profile`);
    return result;
  }
)


export const fetchDeleteProvidersPhotos = createAsyncThunk(
  "fetchDeleteProvidersPhotos",
  async ({providersId,displayId}) => {
    const result = await FetchRequestHandler("delete", `${baseUrl}api/providers/${providersId}/photos/${displayId}`);
    return result;
  }
)


export const fetchUpdateProvidersPhotos = createAsyncThunk(
  "fetchUpdateProvidersPhotos",
  async ({providersId, payload}) => {
    const result = await FetchRequestHandler("post", `${baseUrl}api/providers/${providersId}/photos`,payload);
    return result;
  }
)